export type EnvType = 'test' | 'staging' | 'production' | 'develop'
export enum EnvEnum {
    TEST = 'test',
    DEVELOP = 'develop',
    STAGING = 'staging',
    PRODUCTION = 'production'
}